import { render, staticRenderFns } from "./QQCallback.vue?vue&type=template&id=0d5b3c76&scoped=true&"
import script from "./QQCallback.vue?vue&type=script&lang=js&"
export * from "./QQCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b3c76",
  null
  
)

export default component.exports